import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketSettings: [],
  tennisMarketSettings: [],
  prematchMarkets: [],
};

export const marketSettingsSlice = createSlice({
  name: 'marketSettings',
  initialState,
  reducers: {
    aGetMarketSettingsSuccess: (state, action) => {
      state.marketSettings = action.payload.marketSettings;
    },
    aGetTennisMarketSettingsSuccess: (state, action) => {
      state.tennisMarketSettings = action.payload.marketSettings;
    },
    aClearMarketSettings: (state) => {
      state.marketSettings = [];
    },
    aClearTennisMarketSettings: (state) => {
      state.tennisMarketSettings = [];
    },
    aGetPrematchMarketSuccess: (state, action) => {
      state.prematchMarkets = action.payload.markets;
    },
  },
});

export const {
  aGetMarketSettingsSuccess,
  aGetTennisMarketSettingsSuccess,
  aClearMarketSettings,
  aClearTennisMarketSettings,
  aGetPrematchMarketSuccess,
} = marketSettingsSlice.actions;

export default marketSettingsSlice.reducer;
